// extracted by mini-css-extract-plugin
export default {"card":"style_card__53+HY"};